import { ErrorMessage } from '@hookform/error-message';
import { Box,
   Typography, Grid, Button, Link } from "@mui/material";
import styled from "styled-components";
import Wellhouse from "@assets/svg/Wellhouse.svg?react";
import LeftArrow from "@assets/svg/AppMarketLeftArrow.svg?react";

export interface IDirectionProps {
  $isRtl: boolean;
}

export const WellHouseSmall = styled(Wellhouse)`
  margin-inline: 12px;
  width: 32px;
  height: 32px;
`;

export const WellHouseTitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9e9e7;
`;
export const EnableMarketStepOneWrapper = styled.section<
  IDirectionProps & { enableMarketStep: number }
>`
  margin-top: 43px;
  padding: 190px;
  display: ${({ enableMarketStep }) =>
    enableMarketStep === 1 ? "flex" : "none"};
  align-items: center;
  justify-content: center;
  height: 410px;
`;
export const StepOneContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 434px;
  border: 1px solid #e3e8ef;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px #1018280d;
  background: #ffffff;
`;

export const WellHouseIcon = styled(Wellhouse)`
  margin-inline: 12px;
  width: 86px;
  height: 86px;
  margin-top: 24px;
`;
export const Title = styled(Typography).attrs({
  sx: {
    fontWeight: 700,
    fontSize: "18px",
    color: "#121926",
    marginTop: "4px",
  },
})``;

export const Paragraph = styled(Typography).attrs({
  sx: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#475467",
    width: "512px",
    marginTop: "4px",
    textAlign: "center",
  },
})``;
export const BoxContainer = styled.span`
  padding-top: 29px;
  padding-inline: 27px;
  background: #fafafb;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 512px;
  height: 168px;
`;

export const BoxTitle = styled(Typography).attrs({
  sx: {
    fontWeight: 700,
    fontSize: "14px",
    color: "#261B6A",
  },
})``;

export const BoxSubtitle = styled(Typography).attrs({
  sx: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#475467",
  },
})``;

export const ConnectBtn = styled.button`
  color: #5b3fff;
  background: #ffffff;
  border: 1px solid #5b3fff;
  margin-top: 10px;
  width: 117px;
  height: 41px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 14px;
`;
export const TechnicalSupportWrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: fit-content;
  border: 1px solid #e3e8ef;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px #1018280d;
  background: #ffffff;
`;
export const SupportTitle = styled(Typography).attrs({
  sx: {
    fontWeight: 700,
    fontSize: "18px",
    color: "#121926",
    marginTop: "4px",
  },
})``;

export const SupportSubtitle = styled(Typography).attrs({
  sx: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#475467",
    marginTop: "4px",
  },
})``;

export const BtnsContainer = styled.span`
  display: flex;
  justify-content: center;
`;

export const ContactUs = styled.button`
  font-weight: 700;
  font-size: 14px;
  width: 148px;
  height: 41px;
  border: 1px solid #5b3fff;
  border-radius: 8px;
  color: #ffffff;
  background: #5b3fff;
  margin-top: 16px;
`;
export const InstallationGuid = styled.p<IDirectionProps>`
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: center;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
  width: 148px;
  height: 41px;
  color: #5b3fff;
  margin-top: 16px;
  margin-inline: ${({ $isRtl }) => ($isRtl ? "0px" : "10px")};
`;

export const StyledLeftArrow = styled(LeftArrow)<IDirectionProps>`
  transform: ${({ $isRtl }) => ($isRtl ? "none" : "rotate(180deg)")};
  width: 16px;
  height: 12px;
`;

// Step 2 section styles
export const EnableMarketStepTwoWrapper = styled.section<
  IDirectionProps & { enableMarketStep: number }
>`
  margin-top: 43px;
  padding: 190px;
  display: ${({ enableMarketStep }) =>
    enableMarketStep === 2 ? "flex" : "none"};
  align-items: center;
  justify-content: center;
  height: fit-content;
  max-height: 600px;
`;

export const StepTwoContainer = styled.div`
position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: fit-content;
  border: 1px solid #e3e8ef;
  border-radius: 12px;
  box-shadow: 0px 1px 2px 0px #1018280d;
  background: #ffffff;
  padding-bottom: 24px;
`;

export const StepTwoTitle = styled(Typography).attrs({
  sx: {
    fontWeight: 700,
    fontSize: "18px",
    color: "#121926",
    marginTop: "4px",
  },
})``;

export const InputContainer = styled.div`

  display: flex;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  width: 550px;
`;

export const ApiInput = styled.input.attrs({
  type: "text",
})`
  flex: 1;
  border: none;
  padding: 12px 16px;
  color: #697586;
  outline: none;
  background-color: white;
  text-align: left;
  font-weight: 400;
  font-size: 16px;
`;

export const InputLabel = styled.div`
margin-block: auto;
  background-color: #f9fafb;
  color: #4b5563;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 400;
  border-right: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 200px;
  text-transform: uppercase;
`;

export const HelperText = styled(Typography).attrs({
  sx: {
    marginTop: "24px",
    fontWeight: 400,
    fontSize: "14px",
    color: "#475467",
    textAlign: "center",
  },
})``;

export const LinkText = styled(Typography).attrs({
  sx: {
    fontWeight: 400,
    fontSize: "14px",
    color: "#475467",
    textAlign: "center",
    marginTop: "8px",
  },
})``;

export const HighlightedLink = styled.span`
  color: #5b3fff;
  cursor: pointer;
  padding-inline: 4px;
`;

export const SaveButton = styled.button`
cursor: pointer;
  width: 150px;
  height: 41px;
  border-radius: 8px;
  color: #ffffff;
  background: #5b3fff;
  border: none;
  margin-top: 24px;
  font-weight: 700;
  font-size: 14px;
`;
export const SupportSection = styled.section<
IDirectionProps & { enableMarketStep: number }
>`
  margin-top: 43px;
  padding-inline: 190px;
  display: ${({ enableMarketStep }) =>
    enableMarketStep === 1 ? "flex" : "none"};
  align-items: start;
  justify-content: start;
`;


export const Error = styled.span<IDirectionProps>`
  top: 56%; /* Position it below the input */
  left: 50%; /* Center horizontally */
  bottom: 0;
  transform: translateX(-50%); /* Ensure true centering */
  margin-top: 4px; /* Small gap from the input */
  border-radius: 8px;
  color: red;
  font-weight: 500;
  font-size: 14px;
  text-align: center; /* Center the error text */
  width: max-content; /* Only take as much width as needed */
  max-width: 90%; /* Prevent overflow on very small screens */
  position: absolute;
  transform: ${(props: IDirectionProps) =>
    props.$isRtl ? "translate(165px, 40px)" : "translate(-270px, 40px)"};
    `;
export const FormElement = styled.div`
  position: relative;
  margin-block: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

// Wrapper for the success card
export const SuccessCard = styled(Box)`
  height: 242px;
  padding: 24px;
  background: #ffffff;
  margin-top: 43px;
  margin-inline: 190px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e3e8ef;
  border-radius: 16px;
`;

// Success text
export const SuccessMessage = styled(Typography).attrs({
  sx: {
    fontSize: "24px",
    fontWeight: 700,
  },
})``;

// Navigation button
export const ReturnButton = styled.button`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 41px;
  border-radius: 8px;
  background: #5b3fff;
  border: none;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
`;
